import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';

const bulletListSx = {
  '& ul': {
    pl: 3,
    color: '#000', // text color black
    mb: 0,
    listStyleType: 'disc',
  },
  '& ul li': {
    color: '#000', // text color black
    fontSize: '1rem',
    mb: 1,
    position: 'relative',
    listStyleType: 'disc',
  },
  '& ul li::marker': {
    color: '#0f63af', // bullet color
  },
};

const TermsandConditions = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: 'fixed',
          top: '60%',
          left: '50%',
          width: { xs: '80vw', md: '40vw' },
          height: { xs: '80vw', md: '30vw' },
          maxWidth: 600,
          maxHeight: 600,
          transform: 'translate(-50%, -50%)',
          zIndex: 0,
          pointerEvents: 'none',
          opacity: 0.08,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="https://dprstorage.b-cdn.net/RW/RW%20LOGO.png"
          alt="Background logo watermark"
          loading="lazy"
          decoding="async"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            filter: 'blur(0.5px)',
            userSelect: 'none',
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              bgcolor: 'rgba(15, 99, 165, 0.4)',
              // backdropFilter: "blur(8px)",
              WebkitBackdropFilter: 'blur(3px)',
              p: 4,
              borderRadius: 3,
              color: '#E0E0E0',
              boxShadow: '0px 4px 20px rgba(255, 255, 255, 0.1)',
              textAlign: 'left',
              mt: 16,
              ...bulletListSx,
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: 'bold', color: '#000' }}
            >
              Terms and Conditions
            </Typography>
            <Typography variant="body2">
              Welcome to{' '}
              <Link
                href="https://rajivwilliams.com"
                target="_blank"
                rel="noopener noreferrer"
                color="#0f63a5"
                underline="always"
              >
                rajivwilliams.com
              </Link>{' '}
              . By using or accessing this Website, you agree to comply with and
              be bound by these Terms & Conditions . If you do not agree with
              any part of these Terms, please do not use the Website.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  You acknowledge that using this Website constitutes your
                  acceptance of these Terms. We may update these Terms at any
                  time by posting a revised version on this page. The updated
                  version will include the “Effective Date” at the top. Your
                  continued use of the Website after any changes indicates your
                  acceptance.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              2. Use of the Website
            </Typography>
            <Typography variant="body2">
              You agree to use the Website only for lawful purposes. You are
              strictly prohibited from:
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>Uploading or transmitting viruses or malicious code</li>
                <li>Interfering with Website operations or servers,</li>
                <li>
                  Attempting to gain unauthorized access to any part of the
                  Website,
                </li>
                <li>Using another’s account or impersonating others.</li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              3. Intellectual Property
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  All content on this Website—including text, graphics, logos,
                  images, and software—is the property of rajivwilliams.com or
                  its licensors and is protected by applicable copyright,
                  trademark, or other intellectual property laws. No content may
                  be copied, distributed, modified, republished, or transmitted
                  without prior written consent.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              4. User Content
            </Typography>
            <Typography variant="body2" paragraph>
              If you submit content (e.g., comments, feedback):
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  You grant rajivwilliams.com a worldwide, non-exclusive,
                  royalty-free license to host, display, reproduce, modify, and
                  distribute it,
                </li>
                <li>
                  You represent and warrant that you have full rights to the
                  content and it doesn’t infringe third-party rights,
                </li>
                <li>
                  You consent to any lawful removal or modification of your
                  content, at our discretion.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              5. Third‑Party Links
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  The Website may link to external websites operated by third
                  parties. We are not responsible for the content, privacy
                  practices, or accuracy of such sites. These links are provided
                  for your convenience; use them at your own risk.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              6. Disclaimer of Warranties
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  The Website is provided “as is” and “as available,” without
                  warranties of any kind, express or implied. rajivwilliams.com
                  disclaims all warranties, including merchantability, fitness
                  for a particular purpose, accuracy, reliability, availability,
                  and non-infringement.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              7. Limitation of Liability
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  To the fullest extent permitted by law, rajivwilliams.com (and
                  its affiliates, officers, directors, employees, and agents)
                  shall not be liable for any:
                </li>
                <li>
                  Direct, indirect, special, incidental, consequential, or
                  punitive damages,
                </li>
                <li>
                  Loss of profits, revenue, data, or business interruption,
                </li>
                <li>
                  Even if we have been advised of the possibility of such
                  damages.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              8. Indemnification
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  You agree to indemnify, defend, and hold harmless
                  rajivwilliams.com and its affiliates from and against all
                  claims, liabilities, damages, losses, costs, or expenses
                  (including legal fees) arising out of:
                </li>
                <li>Your use of the Website,</li>
                <li>Your content submissions or transmissions,</li>
                <li>Your violation of these Terms.</li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              9. Termination
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  We may suspend or terminate your access to the Website for any
                  reason, including violations of these Terms or unlawful
                  conduct.
                </li>
                <li>
                  Sections 3 (Intellectual Property), 6 (Disclaimer), 7
                  (Liability), 8 (Indemnification), and 10 (Governing Law) will
                  survive termination.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              10. Governing Law & Jurisdiction
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  These Terms are governed by and constructed in accordance with
                  the laws of Telangana without regard to conflict of laws
                  principles.
                </li>
                <li>
                  You consent to the exclusive jurisdiction of courts in India
                  for any disputes arising under these Terms.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              11. Severability
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  If any provision of these Terms is held invalid or
                  unenforceable, the remaining provisions will continue in full
                  force.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              12. No Waiver
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  Our failure to enforce any provision does not constitute a
                  waiver or limitation of our rights to enforce it later.
                </li>
              </ul>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: '#000' }}>
              13. Entire Agreement
            </Typography>
            <Typography variant="body2" component="div">
              <ul>
                <li>
                  These Terms and our Privacy Policy (if applicable) constitute
                  the entire agreement between you and rajivwilliams.com
                  regarding your use of the Website.
                </li>
              </ul>
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default TermsandConditions;
